// Contact Member modal shell - UI only, no API calls
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from 'components/ui/dialog';
import { Mail } from 'lucide-react';

const ContactMemberModal = ({ open, onClose, member }) => {
  if (!member) return null;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:tw-max-w-md">
        <DialogHeader>
          <DialogTitle className="tw-flex tw-items-center tw-gap-2">
            <Mail className="tw-h-5 tw-w-5" />
            Contact Member
          </DialogTitle>
          <DialogDescription>Send a message to a crew member via email or SMS.</DialogDescription>
        </DialogHeader>
        <div className="tw-space-y-4 tw-py-4">
          <p className="tw-text-sm tw-text-muted-foreground tw-m-0">
            Send a message to {member?.firstName} {member?.lastName} ({member?.email}).
          </p>
          <div>
            <label className="tw-text-sm tw-font-medium tw-text-foreground tw-block tw-mb-1.5">Subject</label>
            <input type="text" disabled placeholder="Message subject..." className="tw-w-full tw-h-9 tw-rounded-md tw-border tw-border-input tw-bg-background tw-px-3 tw-text-sm" />
          </div>
          <div>
            <label className="tw-text-sm tw-font-medium tw-text-foreground tw-block tw-mb-1.5">Message</label>
            <textarea disabled placeholder="Type your message..." rows={4} className="tw-w-full tw-rounded-md tw-border tw-border-input tw-bg-background tw-px-3 tw-py-2 tw-text-sm tw-resize-none" />
          </div>
          <div className="tw-flex tw-items-center tw-gap-4">
            <label className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-muted-foreground">
              <input type="checkbox" checked disabled readOnly className="tw-rounded" /> Send via Email
            </label>
            <label className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-muted-foreground">
              <input type="checkbox" disabled className="tw-rounded" /> Send via SMS
            </label>
          </div>
        </div>
        <DialogFooter>
          <button onClick={() => onClose(false)} className="tw-h-9 tw-px-4 tw-rounded-md tw-border tw-border-input tw-bg-background tw-text-sm tw-font-medium hover:tw-bg-accent tw-cursor-pointer">Cancel</button>
          <button disabled className="tw-h-9 tw-px-4 tw-rounded-md tw-bg-primary tw-text-primary-foreground tw-text-sm tw-font-medium tw-border-0 tw-opacity-50 tw-cursor-not-allowed">Send</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ContactMemberModal;
